import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

import {
  ActiveErrorData,
  ActiveErrorsStore,
  DIAGNOSTICS_CONNECTION_STATUS,
  InstallationDetailsStore,
  RemoteDiagnosticsStore,
} from '@store';

import { DatesService } from '../../../../../shared/services/dates.service';

@Component({
  selector: 'app-locked-system-error',
  templateUrl: './locked-system-error.component.html',
  styleUrls: ['./locked-system-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LockedSystemErrorComponent implements OnInit, OnDestroy {
  connectionStatus: DIAGNOSTICS_CONNECTION_STATUS;
  installationLocalTimeOfErrorCreatedAt: string;

  readonly diagnosticsConnectionStatus = DIAGNOSTICS_CONNECTION_STATUS;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  @Input() systemLockedError: ActiveErrorData;
  @Output() navigate = new EventEmitter<{
    gatewaySerial: string;
    deviceSerial: string;
    activeErrorId: number;
    isLockedSystem?: boolean;
  }>();

  constructor(
    public installationDetailsStore: InstallationDetailsStore,
    public activeErrorsStore: ActiveErrorsStore,
    private datesService: DatesService,
    private remoteDiagnosticsStore: RemoteDiagnosticsStore,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscribeToTimezone();

    this.remoteDiagnosticsStore
      .getConnectionStatus()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((status) => {
        this.connectionStatus = status;
        this.cdr.detectChanges();
      });
  }

  navigateToErrorDetails(): void {
    this.navigate.emit({
      gatewaySerial: this.systemLockedError.gatewaySerial,
      deviceSerial: this.systemLockedError.deviceSerial,
      activeErrorId: this.systemLockedError.id,
      isLockedSystem: true,
    });
  }

  private subscribeToTimezone(): void {
    this.installationDetailsStore.installationTimezone$
      .pipe(
        filter(Boolean),
        map((val: string) => val),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((timeZone) => {
        this.installationLocalTimeOfErrorCreatedAt = this.datesService.getMomentFormattedDateForSpecificTimezone(
          this.systemLockedError.createdAt,
          timeZone
        );
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
